import i18n from 'i18n';

export default {
  // home: i18n.t("HOME_KEY"),
  environments: i18n.t('ENVIRONMENTS_KEY'),
  //virtualizerChoice: i18n.t("VIRTUALIZER_CHOICE_KEY"),
};
